module.exports = __webpack_public_path__ + "static/media/GooglePixel4a.13d0f6f7.png";